export default {"src":"/_next/static/media/tbx.692e3fa1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};